/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.

import dynamic from 'next/dynamic';
import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as ProductListTrial from 'src/components/ProductListTrial';
import * as Promo from 'src/components/Promo';
import * as RichText from 'src/components/RichText';
import * as RowSplitter from 'src/components/RowSplitter';
import * as Title from 'src/components/Title';
import * as AboutStore from 'src/components/AboutStore/AboutStore';
import * as AccountManagementSplitter from 'src/components/AccountManagement/AccountManagementSplitter';
import * as PSPCrowdTwistLoyalty from 'src/components/AccountManagement/CrowdTwistLoyalty/PSPCrowdTwistLoyalty';
import * as querygraphql from 'src/components/AccountManagement/CrowdTwistLoyalty/query.graphql';
import * as JumpMenu from 'src/components/AccountManagement/CrowdTwistLoyaltyJumpMenu/JumpMenu';
import * as PSPCrowdTwistLoyaltyProgressBar from 'src/components/AccountManagement/CrowdTwistLoyaltyProgressBar/PSPCrowdTwistLoyaltyProgressBar';
import * as CrowdTwistSSO from 'src/components/AccountManagement/CrowdTwistSSO/CrowdTwistSSO';
import * as LeftNavigation from 'src/components/AccountManagement/LeftNavigation/LeftNavigation';
import * as AvailableOffers from 'src/components/AccountManagement/LoyaltyProgramTabs/AvailableOffers';
import * as EarnedOffers from 'src/components/AccountManagement/LoyaltyProgramTabs/EarnedOffers';
import * as InProgressOffers from 'src/components/AccountManagement/LoyaltyProgramTabs/InProgressOffers';
import * as LoyaltyProgramTabs from 'src/components/AccountManagement/LoyaltyProgramTabs/LoyaltyProgramTabs';
import * as ContentHubImage from 'src/components/AccountManagement/LoyaltyProgramTabs/ContentHubImages/ContentHubImage';
import * as queries from 'src/components/AccountManagement/LoyaltyProgramTabs/ContentHubImages/graphQl/queries';
import * as LoyaltyTabSection from 'src/components/AccountManagement/LoyaltyTabSection/LoyaltyTabSection';
import * as OldLoyaltyWidget from 'src/components/AccountManagement/LoyaltyTabSection/OldLoyaltyWidget/OldLoyaltyWidget';
import * as ServiceRewardsWidget from 'src/components/AccountManagement/LoyaltyTabSection/ServiceRewardsWidget/ServiceRewardsWidget';
import * as MobileBackToMenu from 'src/components/AccountManagement/MobileBackToMenu/MobileBackToMenu';
import * as MobileBackToMenuEE from 'src/components/AccountManagement/MobileBackToMenu/MobileBackToMenuEE';
import * as MobileBackToMenuWrapper from 'src/components/AccountManagement/MobileBackToMenu/MobileBackToMenuWrapper';
import * as ProgramOffersAndRewardsTabsContainer from 'src/components/AccountManagement/ProgramOffersAndRewardsTabs/ProgramOffersAndRewardsTabsContainer';
import * as QuickLinks from 'src/components/AccountManagement/QuickLinks/QuickLinks';
import * as UserGroupProfileImage from 'src/components/AccountManagement/UserGroupProfileImage/UserGroupProfileImage';
import * as AccountUnlockForm from 'src/components/AccountUnlockForm/AccountUnlockForm';
import * as AlertPromo from 'src/components/AlertPromo/AlertPromo';
import * as AlternatingGrid from 'src/components/AlternatingGrid/AlternatingGrid';
import * as AnchorJumpLink from 'src/components/AnchorJumpLink/AnchorJumpLink';
import * as AnchorNavigation from 'src/components/AnchorNavigation/AnchorNavigation';
import * as AuthenticationCheck from 'src/components/AuthenticationCheck/AuthenticationCheck';
import * as AutoshipAlertMessage from 'src/components/AutoshipAlertMessage/AutoshipAlertMessage';
import * as BVContainer from 'src/components/BVContainer/BVContainer';
import * as BackToTop from 'src/components/BackToTop/BackToTop';
import * as BannerCta from 'src/components/BannerCta/BannerCta';
import * as BazaarVoiceReview from 'src/components/BazaarVoiceReview/BazaarVoiceReview';
import * as BVPLPRating from 'src/components/BazarVoice/BVPLPRating';
import * as BVRatingSummary from 'src/components/BazarVoice/BVRatingSummary';
import * as BazarVoiceReviews from 'src/components/BazarVoice/BazarVoiceReviews';
import * as BazarVoiceToken from 'src/components/BazarVoice/BazarVoiceToken';
import * as BrandsListing from 'src/components/BrandsListing/BrandsListing';
import * as BreadCrumbDefault from 'src/components/Breadcrumb/BreadCrumbDefault';
import * as BreadCrumbWithSiblings from 'src/components/Breadcrumb/BreadCrumbWithSiblings';
import * as Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import * as BreadcrumbPDP from 'src/components/Breadcrumb/BreadcrumbPDP';
import * as OnlyBreadCrumbSiblings from 'src/components/Breadcrumb/OnlyBreadCrumbSiblings';
import * as breadcrumbgraphql from 'src/components/Breadcrumb/breadcrumb.graphql';
import * as CancelAutoship from 'src/components/CancelAutoship/CancelAutoship';
import * as CancelledAutoship from 'src/components/CancelledAutoship/CancelledAutoship';
import * as CareerStoreLocator from 'src/components/CareerStoreLocator/CareerStoreLocator';
import * as CarouselThreeColumn from 'src/components/CarouselThreeColumn/CarouselThreeColumn';
import * as AddToCart from 'src/components/Cart/AddToCart';
import * as CartItemListing from 'src/components/Cart/CartItemListing/CartItemListing';
import * as ChangeMyStore from 'src/components/ChangeMyStore/ChangeMyStore';
import * as AddATip from 'src/components/Checkout/AddATip/AddATip';
import * as BillingAddress from 'src/components/Checkout/BillingAddress/BillingAddress';
import * as CheckoutPayment from 'src/components/Checkout/CheckoutPayment/CheckoutPayment';
import * as DeliveryAddress from 'src/components/Checkout/DeliveryAddress/DeliveryAddress';
import * as DeliveryFrequency from 'src/components/Checkout/DeliveryFrequency/DeliveryFrequency';
import * as ErrorLabel from 'src/components/Checkout/ErrorLabel/ErrorLabel';
import * as FindStorePopupWidget from 'src/components/Checkout/FulfillmentSwitcher/FindStorePopupWidget';
import * as FulfillmentSwitch from 'src/components/Checkout/FulfillmentSwitcher/FulfillmentSwitch';
import * as FulfillmentSwitcher from 'src/components/Checkout/FulfillmentSwitcher/FulfillmentSwitcher';
import * as MyItems from 'src/components/Checkout/MyItems/MyItems';
import * as OrderConfirmation from 'src/components/Checkout/OrderConfirmation/OrderConfirmation';
import * as OrderConfirmationSummary from 'src/components/Checkout/OrderConfirmationSummary/OrderConfirmationSummary';
import * as PickupAddress from 'src/components/Checkout/PickupAddress/PickupAddress';
import * as preflight from 'src/components/Checkout/helper/preflight';
import * as CheckoutHeader from 'src/components/CheckoutHeader/CheckoutHeader';
import * as ContactUsForm from 'src/components/ContactUsForm/ContactUsForm';
import * as CookiePopup from 'src/components/Cookie/CookiePopup';
import * as Credentials from 'src/components/Credentials/Credentials';
import * as CtaBannerVariant from 'src/components/CtaBannerVariant/CtaBannerVariant';
import * as CultureContainer from 'src/components/CultureContainer/CultureContainer';
import * as DeleteAccount from 'src/components/DeleteAccount/DeleteAccount';
import * as Divider from 'src/components/Divider/Divider';
import * as DoubleCallout from 'src/components/DoubleCallout/DoubleCallout';
import * as InternalServerError from 'src/components/Error/InternalServerError';
import * as Events from 'src/components/Events/Events';
import * as faqContainer from 'src/components/FAQContainer/faqContainer';
import * as faqAccordion from 'src/components/FAQContainer/helpers/faqAccordion';
import * as faqTab from 'src/components/FAQContainer/helpers/faqTab';
import * as svgIcons from 'src/components/FAQContainer/helpers/svgIcons';
import * as FavouriteFriends from 'src/components/FavouriteFriends/FavouriteFriends';
import * as FeaturedProduct from 'src/components/FeaturedProduct/FeaturedProduct';
import * as FeaturedTiles from 'src/components/FeaturedTiles/FeaturedTiles';
import * as Footer from 'src/components/Footer/Footer';
import * as FooterNav from 'src/components/Footer/FooterNav';
import * as FrequentlyBrought from 'src/components/FrequentlyBrought/FrequentlyBrought';
import * as FullWidthVideoTile from 'src/components/FullWidthVideoTile/FullWidthVideoTile';
import * as GeoLocationPopup from 'src/components/GeoLocationPopup/GeoLocationPopup';
import * as DesktopMenu from 'src/components/GlobalHeader/DesktopMenu';
import * as GlobalHeader from 'src/components/GlobalHeader/GlobalHeader';
import * as MobileNav from 'src/components/GlobalHeader/MobileNav';
import * as MobileUtility from 'src/components/GlobalHeader/MobileUtility';
import * as MobilesubNav from 'src/components/GlobalHeader/MobilesubNav';
import * as UtilityNav from 'src/components/GlobalHeader/UtilityNav';
import * as profilegraphql from 'src/components/GlobalHeader/profile.graphql';
import * as ScheduleAppointment from 'src/components/Grooming/ScheduleAppointment/ScheduleAppointment';
import * as HeaderR2 from 'src/components/HeaderR2/HeaderR2';
import * as Heading from 'src/components/Heading/Heading';
import * as HeadingWithDescription from 'src/components/HeadingWithDescription/HeadingWithDescription';
import * as Hero from 'src/components/Hero/Hero';
import * as HeroCarousel from 'src/components/HeroCarousel/HeroCarousel';
import * as IconWithDescription from 'src/components/IconWithDescription/IconWithDescription';
import * as JobInquiryForm from 'src/components/JobInquiryForm/JobInquiryForm';
import * as LandingPageBanner from 'src/components/LandingPageBanner/LandingPageBanner';
import * as Loader from 'src/components/Loader/Loader';
import * as LocalOffers from 'src/components/LocalOffers/LocalOffers';
import * as LoginContent from 'src/components/LoginContent/LoginContent';
import * as LoyaltyTermsOfUse from 'src/components/LoyaltyTermsOfUse/LoyaltyTermsOfUse';
import * as MaintainanceMode from 'src/components/MaintainanceMode/MaintainanceMode';
import * as MeetTeam from 'src/components/MeetTeam/MeetTeam';
import * as MiniCart from 'src/components/MiniCart/MiniCart';
import * as MultiColumnCarousel from 'src/components/MultiColumnCarousel/MultiColumnCarousel';
import * as MultiColumnContainer from 'src/components/MultiColumnContainer/MultiColumnContainer';
import * as MultiColumnItem from 'src/components/MultiColumnItem/MultiColumnItem';
import * as MyAccountBillingAddress from 'src/components/MyAccountBillingAddress/MyAccountBillingAddress';
import * as MyAccountChangePassword from 'src/components/MyAccountChangePassword/MyAccountChangePassword';
import * as MyAccountDeliveryAddress from 'src/components/MyAccountDeliveryAddress/MyAccountDeliveryAddress';
import * as MyAccountDetails from 'src/components/MyAccountDetails/MyAccountDetails';
import * as MyAccountHomeAddress from 'src/components/MyAccountHomeAddress/MyAccountHomeAddress';
import * as MyAccountSpecialInstructions from 'src/components/MyAccountSpecialInstructions/MyAccountSpecialInstructions';
import * as MyAutoship from 'src/components/MyAutoship/MyAutoship';
import * as MyAutoshipAddAtip from 'src/components/MyAutoshipAddAtip/MyAutoshipAddAtip';
import * as MyFavorite from 'src/components/MyFavorite/MyFavorite';
import * as MyPet from 'src/components/MyPet/MyPet';
import * as NewsLetter from 'src/components/NewsLetter/NewsLetter';
import * as NextDelivery from 'src/components/NextDelivery/NextDelivery';
import * as CouponCode from 'src/components/OrderSummary/CouponCode';
import * as OrderSummary from 'src/components/OrderSummary/OrderSummary';
import * as PLPMarketingTile from 'src/components/PLPMarketingTile/PLPMarketingTile';
import * as BasePersonalizedImage from 'src/components/PersonalizedImage/BasePersonalizedImage';
import * as PersonalizedImage from 'src/components/PersonalizedImage/PersonalizedImage';
import * as PlainHTML from 'src/components/PlainHTML/PlainHTML';
import * as PopularCategory from 'src/components/PopularCategory/PopularCategory';
import * as PositionsGrid from 'src/components/PositionsGrid/PositionsGrid';
import * as ProductDetail from 'src/components/ProductDetail/ProductDetail';
import * as ChangeStore from 'src/components/ProductDetail/ChangeStorePopup/ChangeStore';
import * as GetStoresWidget from 'src/components/ProductDetail/ChangeStorePopup/GetStoresWidget';
import * as ProductDetailR2 from 'src/components/ProductDetailR2/ProductDetailR2';
import * as ProductDetailSliderComponent from 'src/components/ProductDetailSliderComponent/ProductDetailSliderComponent';
import * as ProductRecommendation from 'src/components/ProductRecommendation/ProductRecommendation';
import * as ProgressBar from 'src/components/ProgressBar/ProgressBar';
import * as PromotionCoupon from 'src/components/PromotionCoupon/PromotionCoupon';
import * as PurchaseDetails from 'src/components/PurchaseDetails/PurchaseDetails';
import * as PurchaseListing from 'src/components/PurchaseListing/PurchaseListing';
import * as PurchaseListingOrderItem from 'src/components/PurchaseListing/PurchaseListingOrderItem';
import * as PurchaseOrderSkeleton from 'src/components/PurchaseListing/PurchaseOrderSkeleton';
import * as AccountVerification from 'src/components/Registration/AccountVerification/AccountVerification';
import * as ForgotPasswordForm from 'src/components/Registration/ForgotPasswordForm/ForgotPasswordForm';
import * as LoginForm from 'src/components/Registration/LoginForm/LoginForm';
import * as RegistrationForm from 'src/components/Registration/RegistrationForm/RegistrationForm';
import * as ResetPasswordForm from 'src/components/Registration/ResetPasswordForm/ResetPasswordForm';
import * as SEOMetadata from 'src/components/SEO/SEOMetadata';
import * as PreviewSearch from 'src/components/Search/PreviewSearch';
import * as ProductListing from 'src/components/Search/ProductListing';
import * as SearchLandingPageBanner from 'src/components/Search/SearchLandingPageBanner';
import * as SearchListing from 'src/components/Search/SearchListing';
import * as SearchMessage from 'src/components/Search/SearchMessage';
import * as ServicePanel from 'src/components/ServicePanel/ServicePanel';
import * as Services from 'src/components/Services/Services';
import * as ShortenedContentBlock from 'src/components/ShortenedContentBlock/ShortenedContentBlock';
import * as SkipDelivery from 'src/components/SkipDelivery/SkipDelivery';
import * as StickyNavigation from 'src/components/StickyNavigation/StickyNavigation';
import * as StoreDetailTab from 'src/components/StoreDetailTab/StoreDetailTab';
import * as StoreInfo from 'src/components/StoreInfo/StoreInfo';
import * as StoreLocator from 'src/components/StoreLocator/StoreLocator';
import * as StoreLocatorGlobalModal from 'src/components/StoreLocatorGlobalModal/StoreLocatorGlobalModal';
import * as GenericStoreLocator from 'src/components/StoreLocatorHelpers/GenericStoreLocator';
import * as GoogleMap from 'src/components/StoreLocatorHelpers/GoogleMap';
import * as ModalStore from 'src/components/StoreLocatorHelpers/ModalStore';
import * as Store from 'src/components/StoreLocatorHelpers/Store';
import * as StoreLocatorGlobalPopup from 'src/components/StoreLocatorHelpers/StoreLocatorGlobalPopup';
import * as StoreLocatorPage from 'src/components/StoreLocatorHelpers/StoreLocatorPage';
import * as StoreNavigation from 'src/components/StoreNavigation/StoreNavigation';
import * as TestimonialCarousel from 'src/components/TestimonialCarousel/TestimonialCarousel';
import * as TextBanner from 'src/components/TextBanner/TextBanner';
import * as TitleBannerWithImageAndLink from 'src/components/TitleBannerWithImageAndLink/TitleBannerWithImageAndLink';
import * as UpcomingAppointments from 'src/components/UpcomingAppointments/UpcomingAppointments';
import * as WarningAutoship from 'src/components/WarningAutoship/WarningAutoship';
import * as WarningDeliveryProfileUpdate from 'src/components/WarningDeliveryProfileUpdate/WarningDeliveryProfileUpdate';
import * as WarningDeliveryThreshold from 'src/components/WarningDeliveryThreshold/WarningDeliveryThreshold';
import * as WarningProfileUpdate from 'src/components/WarningProfileUpdate/WarningProfileUpdate';
import * as WarningStoreChange from 'src/components/WarningStoreChange/WarningStoreChange';
import * as WarningSubmittingCart from 'src/components/WarningSubmittingCart/WarningSubmittingCart';
import * as WarningUnsavedChanges from 'src/components/WarningUnsavedChanges/WarningUnsavedChanges';
const Yelp = {
  module: () => import('src/components/Yelp/Yelp.dynamic'),
  element: (isEditing?: boolean) => isEditing ? require('src/components/Yelp/Yelp.dynamic')?.default : dynamic(Yelp.module)
}

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('FEAASScripts', FEAASScripts);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('ProductListTrial', ProductListTrial);
components.set('Promo', Promo);
components.set('RichText', RichText);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('AboutStore', AboutStore);
components.set('AccountManagementSplitter', AccountManagementSplitter);
components.set('PSPCrowdTwistLoyalty', PSPCrowdTwistLoyalty);
components.set('query.graphql', querygraphql);
components.set('JumpMenu', JumpMenu);
components.set('PSPCrowdTwistLoyaltyProgressBar', PSPCrowdTwistLoyaltyProgressBar);
components.set('CrowdTwistSSO', CrowdTwistSSO);
components.set('LeftNavigation', LeftNavigation);
components.set('AvailableOffers', AvailableOffers);
components.set('EarnedOffers', EarnedOffers);
components.set('InProgressOffers', InProgressOffers);
components.set('LoyaltyProgramTabs', LoyaltyProgramTabs);
components.set('ContentHubImage', ContentHubImage);
components.set('queries', queries);
components.set('LoyaltyTabSection', LoyaltyTabSection);
components.set('OldLoyaltyWidget', OldLoyaltyWidget);
components.set('ServiceRewardsWidget', ServiceRewardsWidget);
components.set('MobileBackToMenu', MobileBackToMenu);
components.set('MobileBackToMenuEE', MobileBackToMenuEE);
components.set('MobileBackToMenuWrapper', MobileBackToMenuWrapper);
components.set('ProgramOffersAndRewardsTabsContainer', ProgramOffersAndRewardsTabsContainer);
components.set('QuickLinks', QuickLinks);
components.set('UserGroupProfileImage', UserGroupProfileImage);
components.set('AccountUnlockForm', AccountUnlockForm);
components.set('AlertPromo', AlertPromo);
components.set('AlternatingGrid', AlternatingGrid);
components.set('AnchorJumpLink', AnchorJumpLink);
components.set('AnchorNavigation', AnchorNavigation);
components.set('AuthenticationCheck', AuthenticationCheck);
components.set('AutoshipAlertMessage', AutoshipAlertMessage);
components.set('BVContainer', BVContainer);
components.set('BackToTop', BackToTop);
components.set('BannerCta', BannerCta);
components.set('BazaarVoiceReview', BazaarVoiceReview);
components.set('BVPLPRating', BVPLPRating);
components.set('BVRatingSummary', BVRatingSummary);
components.set('BazarVoiceReviews', BazarVoiceReviews);
components.set('BazarVoiceToken', BazarVoiceToken);
components.set('BrandsListing', BrandsListing);
components.set('BreadCrumbDefault', BreadCrumbDefault);
components.set('BreadCrumbWithSiblings', BreadCrumbWithSiblings);
components.set('Breadcrumb', Breadcrumb);
components.set('BreadcrumbPDP', BreadcrumbPDP);
components.set('OnlyBreadCrumbSiblings', OnlyBreadCrumbSiblings);
components.set('breadcrumb.graphql', breadcrumbgraphql);
components.set('CancelAutoship', CancelAutoship);
components.set('CancelledAutoship', CancelledAutoship);
components.set('CareerStoreLocator', CareerStoreLocator);
components.set('CarouselThreeColumn', CarouselThreeColumn);
components.set('AddToCart', AddToCart);
components.set('CartItemListing', CartItemListing);
components.set('ChangeMyStore', ChangeMyStore);
components.set('AddATip', AddATip);
components.set('BillingAddress', BillingAddress);
components.set('CheckoutPayment', CheckoutPayment);
components.set('DeliveryAddress', DeliveryAddress);
components.set('DeliveryFrequency', DeliveryFrequency);
components.set('ErrorLabel', ErrorLabel);
components.set('FindStorePopupWidget', FindStorePopupWidget);
components.set('FulfillmentSwitch', FulfillmentSwitch);
components.set('FulfillmentSwitcher', FulfillmentSwitcher);
components.set('MyItems', MyItems);
components.set('OrderConfirmation', OrderConfirmation);
components.set('OrderConfirmationSummary', OrderConfirmationSummary);
components.set('PickupAddress', PickupAddress);
components.set('preflight', preflight);
components.set('CheckoutHeader', CheckoutHeader);
components.set('ContactUsForm', ContactUsForm);
components.set('CookiePopup', CookiePopup);
components.set('Credentials', Credentials);
components.set('CtaBannerVariant', CtaBannerVariant);
components.set('CultureContainer', CultureContainer);
components.set('DeleteAccount', DeleteAccount);
components.set('Divider', Divider);
components.set('DoubleCallout', DoubleCallout);
components.set('InternalServerError', InternalServerError);
components.set('Events', Events);
components.set('faqContainer', faqContainer);
components.set('faqAccordion', faqAccordion);
components.set('faqTab', faqTab);
components.set('svgIcons', svgIcons);
components.set('FavouriteFriends', FavouriteFriends);
components.set('FeaturedProduct', FeaturedProduct);
components.set('FeaturedTiles', FeaturedTiles);
components.set('Footer', Footer);
components.set('FooterNav', FooterNav);
components.set('FrequentlyBrought', FrequentlyBrought);
components.set('FullWidthVideoTile', FullWidthVideoTile);
components.set('GeoLocationPopup', GeoLocationPopup);
components.set('DesktopMenu', DesktopMenu);
components.set('GlobalHeader', GlobalHeader);
components.set('MobileNav', MobileNav);
components.set('MobileUtility', MobileUtility);
components.set('MobilesubNav', MobilesubNav);
components.set('UtilityNav', UtilityNav);
components.set('profile.graphql', profilegraphql);
components.set('ScheduleAppointment', ScheduleAppointment);
components.set('HeaderR2', HeaderR2);
components.set('Heading', Heading);
components.set('HeadingWithDescription', HeadingWithDescription);
components.set('Hero', Hero);
components.set('HeroCarousel', HeroCarousel);
components.set('IconWithDescription', IconWithDescription);
components.set('JobInquiryForm', JobInquiryForm);
components.set('LandingPageBanner', LandingPageBanner);
components.set('Loader', Loader);
components.set('LocalOffers', LocalOffers);
components.set('LoginContent', LoginContent);
components.set('LoyaltyTermsOfUse', LoyaltyTermsOfUse);
components.set('MaintainanceMode', MaintainanceMode);
components.set('MeetTeam', MeetTeam);
components.set('MiniCart', MiniCart);
components.set('MultiColumnCarousel', MultiColumnCarousel);
components.set('MultiColumnContainer', MultiColumnContainer);
components.set('MultiColumnItem', MultiColumnItem);
components.set('MyAccountBillingAddress', MyAccountBillingAddress);
components.set('MyAccountChangePassword', MyAccountChangePassword);
components.set('MyAccountDeliveryAddress', MyAccountDeliveryAddress);
components.set('MyAccountDetails', MyAccountDetails);
components.set('MyAccountHomeAddress', MyAccountHomeAddress);
components.set('MyAccountSpecialInstructions', MyAccountSpecialInstructions);
components.set('MyAutoship', MyAutoship);
components.set('MyAutoshipAddAtip', MyAutoshipAddAtip);
components.set('MyFavorite', MyFavorite);
components.set('MyPet', MyPet);
components.set('NewsLetter', NewsLetter);
components.set('NextDelivery', NextDelivery);
components.set('CouponCode', CouponCode);
components.set('OrderSummary', OrderSummary);
components.set('PLPMarketingTile', PLPMarketingTile);
components.set('BasePersonalizedImage', BasePersonalizedImage);
components.set('PersonalizedImage', PersonalizedImage);
components.set('PlainHTML', PlainHTML);
components.set('PopularCategory', PopularCategory);
components.set('PositionsGrid', PositionsGrid);
components.set('ProductDetail', ProductDetail);
components.set('ChangeStore', ChangeStore);
components.set('GetStoresWidget', GetStoresWidget);
components.set('ProductDetailR2', ProductDetailR2);
components.set('ProductDetailSliderComponent', ProductDetailSliderComponent);
components.set('ProductRecommendation', ProductRecommendation);
components.set('ProgressBar', ProgressBar);
components.set('PromotionCoupon', PromotionCoupon);
components.set('PurchaseDetails', PurchaseDetails);
components.set('PurchaseListing', PurchaseListing);
components.set('PurchaseListingOrderItem', PurchaseListingOrderItem);
components.set('PurchaseOrderSkeleton', PurchaseOrderSkeleton);
components.set('AccountVerification', AccountVerification);
components.set('ForgotPasswordForm', ForgotPasswordForm);
components.set('LoginForm', LoginForm);
components.set('RegistrationForm', RegistrationForm);
components.set('ResetPasswordForm', ResetPasswordForm);
components.set('SEOMetadata', SEOMetadata);
components.set('PreviewSearch', PreviewSearch);
components.set('ProductListing', ProductListing);
components.set('SearchLandingPageBanner', SearchLandingPageBanner);
components.set('SearchListing', SearchListing);
components.set('SearchMessage', SearchMessage);
components.set('ServicePanel', ServicePanel);
components.set('Services', Services);
components.set('ShortenedContentBlock', ShortenedContentBlock);
components.set('SkipDelivery', SkipDelivery);
components.set('StickyNavigation', StickyNavigation);
components.set('StoreDetailTab', StoreDetailTab);
components.set('StoreInfo', StoreInfo);
components.set('StoreLocator', StoreLocator);
components.set('StoreLocatorGlobalModal', StoreLocatorGlobalModal);
components.set('GenericStoreLocator', GenericStoreLocator);
components.set('GoogleMap', GoogleMap);
components.set('ModalStore', ModalStore);
components.set('Store', Store);
components.set('StoreLocatorGlobalPopup', StoreLocatorGlobalPopup);
components.set('StoreLocatorPage', StoreLocatorPage);
components.set('StoreNavigation', StoreNavigation);
components.set('TestimonialCarousel', TestimonialCarousel);
components.set('TextBanner', TextBanner);
components.set('TitleBannerWithImageAndLink', TitleBannerWithImageAndLink);
components.set('UpcomingAppointments', UpcomingAppointments);
components.set('WarningAutoship', WarningAutoship);
components.set('WarningDeliveryProfileUpdate', WarningDeliveryProfileUpdate);
components.set('WarningDeliveryThreshold', WarningDeliveryThreshold);
components.set('WarningProfileUpdate', WarningProfileUpdate);
components.set('WarningStoreChange', WarningStoreChange);
components.set('WarningSubmittingCart', WarningSubmittingCart);
components.set('WarningUnsavedChanges', WarningUnsavedChanges);
components.set('Yelp', Yelp);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
